const rooms = [441,443,261, 228];
export {rooms}
const breederRooms = [441,443, 228];
export {breederRooms}
const experimentRooms = [261];
export {experimentRooms}